/* eslint-disable react/prop-types */
import React from 'react';
import { Formik, Form } from 'formik';
import ReCAPTCHA from 'react-google-recaptcha';

import PasswordMessage from '../passwordMessage';
import RegistrationModal from '../modal';
import { CONSTANT, RECAPTCHA_SITE_KEY } from '../../utils/constant';
import MultiProvinces from './fields/multiProvinces';
import MultiChannels from './fields/multiChannels';
import { Field, Dealership } from './fields';

const SalesSupportForm = ({
  schema,
  initialValues,
  onSubmit,
  showModal,
  loading,
  onCaptchaChange,
  labels,
  provinces,
  channels,
  confirmationDialog,
  dealerships
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
      showModal={showModal}
    >
      {({ values, errors, touched, setFieldValue, setFieldTouched }) => {
        const isChannelCorpStore = values.channel.includes(
          CONSTANT.CHANNELS.CORP_STORE.toString()
        );
        const isDealerChannel = values.channel.includes(
          CONSTANT.CHANNELS.DEALER.toString()
        );

        return (
          <Form>
            {showModal && <RegistrationModal show />}
            <Field
              name="firstName"
              label={labels.FIRST_NAME}
              touched={touched}
              errors={errors}
              required
            />
            <Field
              name="lastName"
              label={labels.LAST_NAME}
              touched={touched}
              errors={errors}
              required
            />
            <Field
              type="email"
              name="email"
              label={labels.EMAIL}
              touched={touched}
              errors={errors}
              comment={`${labels.NOTE}: ${labels.EMAIL_MESSAGE}`}
              required
            />
            <Field
              type="password"
              name="password"
              label={labels.PASSWORD}
              touched={touched}
              errors={errors}
              style={{ width: '100%' }}
              required
            />
            <PasswordMessage labels={labels} />
            <MultiProvinces
              label={labels.SELECT_PROVINCE}
              name="province"
              list={provinces}
              errors={errors}
              touched={touched}
            />
            <MultiChannels
              label={labels.SELECT_CHANNEL}
              name="channel"
              list={channels}
              errors={errors}
              touched={touched}
            />
            {isDealerChannel && (
              <>
                <Dealership
                  label={labels.SELECT_DEALERSHIP}
                  errors={errors}
                  touched={touched}
                  dealerships={dealerships}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                />
                <Field
                  name="channelOrgCode"
                  label={labels.CHANNEL_ORGANIZATION_CODE}
                  touched={touched}
                  errors={errors}
                  required
                />
              </>
            )}
            <Field
              name="contactNumber"
              label={labels.CONTACT_NUMBER}
              touched={touched}
              errors={errors}
              required
            />
            <Field
              name="xid"
              label={labels.XID_TID}
              touched={touched}
              errors={errors}
              required
            />
            {isChannelCorpStore && (
              <Field
                name="outletCode"
                label={labels.OUTLET_CODE}
                touched={touched}
                errors={errors}
                required
              />
            )}
            <div
              style={{ position: 'relative' }}
              className={`input-container ${
                errors.recaptcha && touched.recaptcha ? 'error' : ''
              }`}
            >
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                name="recaptcha"
                onChange={onCaptchaChange}
              />
            </div>
            <div id="continue_button" style={{ marginTop: 20 }}>
              {!loading ? (
                <span>
                  <button
                    type="submit"
                    className="frg-button button-wide color-green"
                  >
                    {labels.CONTINUE}
                  </button>
                </span>
              ) : (
                <span>
                  <button
                    className="frg-button button-wide color-green"
                    type="button"
                  >
                    <i className="fa fa-refresh fa-spin" />
                    {confirmationDialog.LOADING}
                  </button>
                </span>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SalesSupportForm;
